// En-tête global: logo + lien vers le site + sélecteur de langue
// Utilisation:
// <Header siteUrl={siteUrl} lang={form.lang} onChangeLang={l=>setLang(l)} t={t} />
import React from 'react';
import { Lang } from '../type/language';

type Props = {
  siteUrl: string;
  lang: Lang;
  onChangeLang: (lang: Lang) => void;
  t: Record<string, string>;
};

export function Header({ siteUrl, lang, onChangeLang, t }: Props) {
  return (
    <div className="header">
      <a href={siteUrl} target="_blank" rel="noreferrer" className="brand">
        <img
          className="brand-logo"
          src={`${process.env.PUBLIC_URL}/Logo_kscan.png`}
          alt="K‑SCAN"
        />
      </a>
      <div className="actions">
        <a className="button ghost" href={siteUrl} target="_blank" rel="noreferrer">
          {t.seeSite}
        </a>
        <label className="lang-select">
          <span>{t.language}</span>
          <select value={lang} onChange={(e) => onChangeLang(e.target.value as Lang)}>
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select>
        </label>
      </div>
    </div>
  );
}
